export const getAllTickets = async (
  welletContext,
  categoryIds,
  limit = 20,
  skip = 0,
  includeInactive = false,
  activityId = null,
  orgId,
) => {
  let url = 'api/Ticket/all';

  return await welletContext.apis.admin.post(url, {
    limit,
    skip,
    categoryIds,
    includeInactive,
    activityId,
    organizationId: orgId,
  });
};

export const getAgeRange = async (welletContext, id) => {
  return await welletContext.apis.manager.get(`api/AgeRange/list?organizationId=${id}`);
};
export const getProductCategories = async (welletContext) => {
  return await welletContext.apis.manager.get(`api/Category/list`);
};
export const getProductGroups = async (welletContext) => {
  return await welletContext.apis.manager.get(`api/Ticket/productGroup/list
`);
};

export const postTicket = async (welletContext, body) => {
  return await welletContext.apis.admin.post(`/api/Ticket`, body);
};

export const getTicketById = async (welletContext, id) => {
  return await welletContext.apis.admin.get(`/api/Ticket/${id}`);
};
export const getTiersById = async (welletContext, id) => {
  return await welletContext.apis.admin.get(`/api/ticket/tiers?organizationId=${id}`);
};
export const putTicket = async (welletContext, body) => {
  return await welletContext.apis.admin.put(`/api/Ticket`, body);
};
export const orderTicketByPriority = async (welletContext, body) => {
  return await welletContext.apis.admin.post(`/api/Ticket/priority`, body);
};
